"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _merchant = require("@/api/merchant");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'warning',
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };
    return {
      loginType: '2',
      headerNum: [{
        type: '2',
        name: '预警设置'
      }],
      merData: {},
      // 默认数据
      submitLoading: false,
      // 提交loading
      keyNum: 0,
      loading: false,
      merInfoForm: {
        warnBalance: 500,
        warnPhone: '',
        isWarn: true
      },
      rules: {
        warnBalance: [{
          required: true,
          message: '请输入预警阈值',
          trigger: 'blur'
        }],
        isWarn: [{
          required: true,
          message: '请输入是否开启预警',
          trigger: 'blur'
        }],
        warnPhone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {},
  created: function created() {
    this.getInfo();
  },
  methods: {
    handlerSubmit: (0, _validate.Debounce)(function (formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _merchant.merchantWarningUpdateApi)(_this.merInfoForm).then(function (res) {
            _this.$message.success('操作成功');
            _this.getInfo();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }),
    // 获取商户信息
    getInfo: function getInfo() {
      var _this2 = this;
      this.loading = true;
      (0, _merchant.getBaseInfoApi)().then(function (res) {
        _this2.merData = res;
        _this2.merInfoForm.warnBalance = res.retailerMerchant.warnBalance;
        _this2.merInfoForm.warnPhone = res.retailerMerchant.warnPhone;
        _this2.merInfoForm.isWarn = res.retailerMerchant.isWarn;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }
};